/**
 * Константы для отображения параметров на карте
 */

/**
 * Ключи параметров, которые должны отображаться в выпадающем списке на карте
 */
export const MAP_DISPLAY_PARAMS_KEYS = [
  "cases_accepted",
  "cases_sent_to_court_with_indictment",
  "cases_suspended",
  "cases_returned_for_investigation",
  "cases_completed_overtime",
  "accused_in_court_cases",
  "persons_rehabilitated"
] as const;

/**
 * Названия параметров для отображения в выпадающем списке на карте.
 * Некоторые названия отличаются от исходных в paramsList для более краткого/точного отображения.
 */
export const MAP_DISPLAY_PARAMS_LABELS = {
  cases_accepted: "Принято к производству дел",
  cases_sent_to_court_with_indictment: "Направлено прокурором в суд",
  cases_suspended: "Приостановлено дел по п. 1-3 ч. 1 ст. 208 УПК РФ",
  cases_returned_for_investigation: "Возвращено дел для дополнительного расследования прокурором и судом",
  cases_completed_overtime: "Окончено дел в сроки свыше предусмотренного УПК РФ",
  accused_in_court_cases: "Число обвиняемых по направленным в суд делам",
  persons_rehabilitated: "Число оправданных и лиц, в отношении которых уголовное преследование прекращено судом по реабилитирующим основаниям (абсолютные цифры)"
} as const;

/**
 * Тип для ключей параметров, отображаемых на карте
 */
export type MapDisplayParamsKey = typeof MAP_DISPLAY_PARAMS_KEYS[number];